<template>
  <div class="lesson-box">
    <v-snackbar v-model="snackbarShown" :multi-line="false">
                  {{ $t('copiedLink') }}
                  <v-btn color="primary" text @click="hideSnackbar">
                    {{ $t('close').toUpperCase() }}</v-btn>
                </v-snackbar>
    <v-hover v-slot:default="{ hover }">
      <v-card
        class="lesson-box__cover mt-4"
        :class="{ 'on-hover': hover || isLoading }"
        color="#D0E6FB"
        :elevation="hover ? 4 : 0"
      >
        <IconLesson />
        <v-row class="fill-height flex-column button-start-container" justify="center">
          <div class="align-self-center">
            <v-btn
              large
              depressed
              rounded
              block
              :loading="isLoading"
              style="opacity:0;display:none"
              :class="{ 'show-btns': hover || isLoading }"
              @click="click"
            >{{ isLive ? $t('enter') : $t('lessonStart') }}</v-btn>
          </div>
        </v-row>
      </v-card>
    </v-hover>

    <div class="lesson-box__content">
      <div class="lesson-box__content-left">
        <span>{{ formatDate(lesson.start.seconds) }}</span>
        <strong>{{ lesson.title }}</strong>
      </div>
      <div class="lesson-box__content-right">
        <v-menu>
          <template v-slot:activator="{ on: menu }">
            <template>
              <v-btn
                class="ma-2"
                color="black"
                icon
                style="text-decoration:none"
                v-on="{ ...menu }"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
          </template>
          <v-list>
            <v-list-item v-clipboard:copy="copiedLink" @click="copyLessonLink(lesson.id)">
              <v-list-item-title>{{ $t('copyLinkExtended') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="recycleLesson(lesson.id)">
              <v-list-item-title>{{ $t('recycle') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openDelete(lesson.id)">
              <v-list-item-title>{{ $t('dialogDelete') }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import IconLesson from '@/assets/icon-lesson.svg';
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    transparent: 'rgba(255, 255, 255, 0)',
    isLoading: false,
    snackbarShown: false,
  }),
  components: {
    IconLesson,
  },
  props: {
    lesson: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters(['auth']),
    isLive() {
      return this.lesson.status === 'live';
    },
    copiedLink() {
      return `${window.location.host}/lesson/${this.lesson.id}`;
    },
  },

  methods: {
    formatDate(seconds) {
      const momentDate = moment.unix(seconds);
      return `${momentDate
        .locale('cs')
        .format('dddd D. M. YYYY')} od ${momentDate.format('HH:mm')}`;
    },
    openDelete(id) {
      this.$emit('open-delete', id);
    },
    recycleLesson(id) {
      this.$emit('recycle-lesson', id);
    },
    copyLessonLink(id) {
      console.log(id);
      this.openSnack();
    },
    openSnack() {
      this.snackbarShown = true;
      setTimeout(() => {
        this.hideSnackbar();
      }, 3000);
    },
    hideSnackbar() {
      this.snackbarShown = false;
    },
    click() {
      if (!this.isLive) {
        this.isLoading = true;
        this.$store
          .dispatch('statusChange', {
            email: this.auth.email,
            lesson: this.lesson.id,
            value: 'live',
          })
          .then(() => {
            this.isLoading = false;
            this.$router.push(`/lesson/${this.lesson.id}`);
            this.$store.dispatch('logEvent', {
              name: 'lesson_launched',
            });
          });
      } else {
        this.$router.push(`/lesson/${this.lesson.id}`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.lesson-box {
  text-decoration: none;
  color: #17173a;

  &__cover {
    position: relative;
    height: 200px;

    svg {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 80px;
      display: block;

      transform: translate(-50%, -50%);
    }

    img {
      display: block;
      width: 100%;
    }
  }

  &__content {
    text-align: left;
    display: flex;
    flex-direction: row;
    padding-left: 6px;

    span {
      display: block;
      font-size: 13px;
      opacity: 0.5;
      margin-top: 16px;
      margin-bottom: 2px;
    }

    strong {
      display: block;
      font-size: 14px;
    }
  }
  &__content-right {
    margin: auto;
    margin-right: 0;
    margin-top: 0;
  }
}

.v-card.on-hover {
  background-color: #0091ff !important;
  -webkit-transition: background-color 250ms linear;
  -ms-transition: background-color 250ms linear;
  transition: background-color 250ms linear;
}

.v-card:not(.on-hover) {
  -webkit-transition: background-color 250ms linear;
  -ms-transition: background-color 250ms linear;
  transition: background-color 250ms linear;
}

.show-btns {
  color: #0091ff !important;
  background-color: rgba(255, 255, 255, 1) !important;
  opacity: 1 !important;
  display: flex !important;
}

.button-start-container {
  height: 100%;
}
</style>
